<template>
  <div class="information-box hit-cursor">
    <div class="box-top" @click="handleClick">
      <div class="title">
        <el-tag size="mini" effect="dark"> 需求方 </el-tag>
        <div class="title-text">{{ data.title || "--" }}</div>
      </div>
      <div class="content">{{ data.detile || "--" }}</div>
      <div class="number">
        生产数量:<span class="number-text">{{
          data.product_number || "--"
        }}</span>
      </div>
    </div>
    <div class="box-footrt">
      <div class="time-look">
        <span>{{ data.created_at || "--" }}</span>
        <span> <i class="el-icon-view"></i>&nbsp;{{ data.view_count || "--" }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "information",
  
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleClick() {
      if(!this.mixCheckLogin()){
        return;
      }
      this.$router.push(
        "/project/factory?id=" + this.data.id + "&type=" + this.type
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.information-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 320px;
  height: 224px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #e7eaf3;
  padding: 15px;
  overflow: hidden;
  box-sizing: border-box;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .title-text {
      display: inline-block;
      margin-left: 12px;
      width: 196px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      font-size: var(--font-size-default-16);
      color: #525666;
    }
  }

  .box-top {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid #e7eaf3;
    padding-bottom: 15px;
  }

  .content {
    width: 280px;
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #7a8199;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    margin-bottom: 10px;
  }

  .number {
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #333333;

    .number-text {
      color: #de911d;
    }
  }

  .time-look {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #7a8199;
    padding-top: 12px;
  }
}
</style>
